export type OnsiteTherapyVisibilityParams = {
  isOnsiteEntrypointsEnabled: boolean
  showProviderSearchOption: boolean
  onsiteProvidersCount: number | undefined
  customerDisplayName: string | null
}

export const computeOnsiteTherapyVisibility = ({
  isOnsiteEntrypointsEnabled,
  showProviderSearchOption,
  onsiteProvidersCount,
  customerDisplayName,
}: OnsiteTherapyVisibilityParams) => {
  const hasOnsiteProviders = (onsiteProvidersCount ?? 0) > 0
  // Only true when providers have been loaded AND the list is empty — not when loading (undefined)
  const showPersistentOnsiteEntrypointSadPath =
    isOnsiteEntrypointsEnabled && showProviderSearchOption && onsiteProvidersCount === 0
  const showOnsiteTherapy =
    Boolean(showProviderSearchOption && hasOnsiteProviders && customerDisplayName) ||
    showPersistentOnsiteEntrypointSadPath

  return { hasOnsiteProviders, showPersistentOnsiteEntrypointSadPath, showOnsiteTherapy }
}

export const useOnsiteTherapyVisibility = (params: OnsiteTherapyVisibilityParams) =>
  computeOnsiteTherapyVisibility(params)
